import React, { useEffect, useRef, useState } from 'react';
import { useLanding } from './LandingKit';

export default function LandingScrollCue() {
  const { c } = useLanding();
  const cueRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const container = cueRef.current?.closest('[data-landing-scroll]');
    if (!container) return undefined;
    const update = () => setScrolled(container.scrollTop > 4);
    update();
    container.addEventListener('scroll', update, { passive: true });
    return () => container.removeEventListener('scroll', update);
  }, []);
  function explore(event) {
    const target = document.getElementById('landing-explore');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }
  return (
    <a ref={cueRef} href="#landing-explore" onClick={explore} aria-label="Explore below" aria-hidden={scrolled || undefined} tabIndex={scrolled ? -1 : undefined} style={{ position: 'absolute', bottom: 18, left: '50%', transform: 'translateX(-50%)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, color: c.muted, opacity: scrolled ? 0 : .7, pointerEvents: scrolled ? 'none' : 'auto', textDecoration: 'none' }}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 5v14m-6-6 6 6 6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  );
}
